import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const LoanEffortlessList = () => {
  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [effortlessList, setEffortlessList] = useState([]);
  const token = sessionStorage.getItem("authToken");

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchEffortless = async (loanId) => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getLoanEffortlessById/${loanId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEffortlessList(res.data.effortless || []);
    } catch (error) {
      console.error("Error fetching effortless:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  useEffect(() => {
    if (selectedLoanId) fetchEffortless(selectedLoanId);
  }, [selectedLoanId]);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Loan Effortless</h2>

        {/* Select Loan */}
        <div className="mb-6">
          <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
          <select
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            value={selectedLoanId}
            onChange={(e) => setSelectedLoanId(e.target.value)}
          >
            <option value="">-- Select Loan --</option>
            {loans.map((loan) => (
              <option key={loan.id} value={loan.id}>
                {loan.name}
              </option>
            ))}
          </select>
        </div>

        {selectedLoanId && (
          <>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-700">Effortless List</h3>
              <Link
                to="/add-loan-effortless"
                state={{ loan_id: selectedLoanId }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                + Add Effortless
              </Link>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {effortlessList.map((item) => (
                <div
                  key={item.id}
                  className="border rounded-lg p-4 shadow-sm bg-gray-50 flex flex-col justify-between"
                >
                  <div>
                    {item.image && (
                      <img
                        src={`${COMMON_API}/ImgUploads/${item.image}`}
                        alt="Effortless"
                        className="w-full h-40 object-cover rounded-lg mb-3"
                      />
                    )}
                    <p className="text-gray-700">{item.description}</p>
                  </div>
                  <div className="flex gap-2 mt-3">
                    <Link
                      to={`/edit-loan-effortless/${item.id}`}
                      className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition"
                    >
                      Edit
                    </Link>
                    <button
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                      onClick={async () => {
                        await axios.delete(`${COMMON_API}/loan/deleteLoanEffortless/${item.id}`, {
                          headers: { Authorization: `Bearer ${token}` },
                        });
                        fetchEffortless(selectedLoanId);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
              {effortlessList.length === 0 && (
                <p className="text-gray-500 text-center col-span-full">
                  No effortless found for this loan.
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoanEffortlessList;
